// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ChatPage } from "../pages/AskV2ChatPage";

export const askV2ChatRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/$chatId",
  component: AskV2ChatRoutePage,
});

function AskV2ChatRoutePage() {
  const { chatId } = askV2ChatRoute.useParams();
  return <AskV2ChatPage chatId={chatId} />;
}
